export const homeRouteConfig = {
  path: "/",
  link: "/",
};
